import React, {forwardRef, useState} from "react";
import {useQueryClient} from "react-query";
import __ from "lodash";
import { InputLabel, Select, MenuItem, Chip, Checkbox, ListItemText, makeStyles } from "@material-ui/core";
import {useComboValues} from "../services/settings";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 200,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 1,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  menuPaper: {
    maxHeight: 300
  }
}));

const ComboMultiSelect = forwardRef((props, ref) => {
  const {id, label, group, subGroup, readOnly, disabled, onChange, renderValue, style, fullWidth, returnType} =
  {
    label: undefined,
    readOnly: false,
    disabled: false,
    subGroup: null,
    renderValue: false,
    style: undefined,
    fullWidth: true,
    displayOnly:false,
    returnType: 'ARRAY',
    ...props
  };

  let values = returnType==='STRING'?`${props.value||props.values||''}`.split(','):props.values;
  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }

  const className = classNames.join(" ");
  const classes = useStyles();
  const [marginTop, setMarginTop] = useState(values?.length > 0 ? 3 : 14)

  const queryClient = useQueryClient();
  const extraKeys = subGroup?[group, subGroup]:[group];

  const combos = useComboValues({queryClient, extraKeys, useCache: true});

  const handleChange = (event) => {
    values = [...event.target.value];
    setMarginTop(values.length > 0 ? 3 : 14);
    onChange(returnType==='STRING'?values.join(','): values);
  };

  return (
    <div >
      {label?
        <InputLabel shrink id={`${id}-label`} style={{position: "relative", marginBottom: -10}} >{label}</InputLabel>
        :<></>
      }
      <Select
        id={id}
        multiple
        style={{...style, ...(label?{marginTop: marginTop}:{})}}
        className={className}
        readOnly={readOnly}
        disabled={disabled}
        fullWidth={fullWidth}
        autoWidth={false}
        onChange={handleChange}
        value={values}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          classes: { paper: classes.menuPaper }
        }}
        renderValue={(values) => {
          return (
            <div className={classes.chips} style={{...props.chipsStyle}}>
              {values.map((code) => {
                const combo = __.find(combos.data, {code: code.trim()});
                if (typeof renderValue === "function") {
                  const value = renderValue(code, combos);
                  return (<Chip key={code} label={value} className={classes.chip} style={{...props.chipStyle}} size={"small"}/>)
                } else if (renderValue) {
                  return (<Chip key={code} label={combo.value} className={classes.chip} style={{...props.chipStyle}} size={"small"}/>)
                } else {
                  return (<Chip key={code} label={code} className={classes.chip} style={{...props.chipStyle}} size={"small"}/>)
                }
              })}
            </div>
          );
        }}
      >
        {(combos && Array.isArray(combos.data)) ?
          combos.data.map((option) => {
            return (
              <MenuItem key={option.code} value={option.code}>
                <Checkbox checked={values ? values.indexOf(option.code) > -1 : false} />
                <ListItemText primary={`${option.code} - ${option.value}`} />
              </MenuItem>);
          }) :
          null
        }
      </Select>
    </div>
  );
})

export default (ComboMultiSelect);
